import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { ReelRejectChip, reelRejectChipMessages, reelRejectChips } from './reelReviewMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the preview, the history and the sheets */
import styles from './ReelReview.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ReelReasonChipsProps {
  picked: ReelRejectChip[];
  onToggle: (chip: ReelRejectChip) => void;
}

/** The reason chips of the reject sheet (design e1). More than one can be on. */
const ReelReasonChipsComponent: React.FC<ReelReasonChipsProps> = ({ picked, onToggle }) => {
  const intl = useIntl();

  const chips = useMemo(
    () =>
      reelRejectChips.map((chip) => {
        const isOn = picked.includes(chip);
        return (
          <button
            key={chip}
            type="button"
            role="checkbox"
            aria-checked={isOn}
            className={clsx(styles.rchip, isOn && styles.rchipOn)}
            onClick={() => onToggle(chip)}
          >
            {intl.formatMessage(reelRejectChipMessages[chip])}
          </button>
        );
      }),
    [intl, onToggle, picked]
  );

  return <div className={styles.chips}>{chips}</div>;
};

export const ReelReasonChips = TypedMemo(ReelReasonChipsComponent);
